import script from "./TerminalsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TerminalsPage.vue?vue&type=script&setup=true&lang=js"

import "./TerminalsPage.vue?vue&type=style&index=0&id=a76981ac&lang=scss&scoped=true"
import "./TerminalsPage.vue?vue&type=style&index=1&id=a76981ac&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a76981ac"]])

export default __exports__